import dayjs, { Dayjs } from 'dayjs'
import { EOrderStatus, ERecieveMethod, ITableOrder } from 'models/orders'

// По правилам площадки у продавца 24 часа на подтверждение заказа
// и ещё 72 часа на передачу его в доставку
export const ORDER_CONFIRMATION_DEADLINE_HOURS = 24
export const ORDER_SHIPPING_DEADLINE_HOURS = 72

export type TOrderDeadlineKind = 'confirmation' | 'shipping'

export interface IOrderDeadline {
  deadline: Dayjs
  hoursLeft: number
  isOverdue: boolean
  kind: TOrderDeadlineKind
}

const getStatusChangeTime = (order: ITableOrder, status: EOrderStatus) =>
  order.status_history?.find((item) => item.status === status)?.changed_at

export const getOrderConfirmationTime = (order: ITableOrder) =>
  order.order_confirmation_time ??
  getStatusChangeTime(order, EOrderStatus.CONFIRMED_BY_SELLER)

// Отсчёт ведём от оплаты: до неё заказ продавцу не виден
const getStartAndLimit = (order: ITableOrder) => {
  const seller = order.seller_id

  if (order.status === EOrderStatus.ON_CONFIRMATION) {
    return {
      start: order.paid_at ?? getStatusChangeTime(order, EOrderStatus.ON_CONFIRMATION) ?? order.createdAt,
      hours:
        (seller?.order_confirmation_deadline_hours || ORDER_CONFIRMATION_DEADLINE_HOURS) +
        (order.confirmation_deadline_extra_hours ?? 0),
      kind: 'confirmation' as TOrderDeadlineKind
    }
  }
  // Самовывоз у продавца отправки не предполагает — срок на неё не отсчитывается
  if (
    order.status === EOrderStatus.CONFIRMED_BY_SELLER &&
    order.receive_method !== ERecieveMethod.PICKUP_POINT
  ) {
    return {
      start: getOrderConfirmationTime(order),
      hours:
        (seller?.order_shipping_deadline_hours || ORDER_SHIPPING_DEADLINE_HOURS) +
        (order.shipping_deadline_extra_hours ?? 0),
      kind: 'shipping' as TOrderDeadlineKind
    }
  }
  return null
}

// Заказы, принятые до появления order_confirmation_time, срока не имеют — там вернётся null.
// Продавцам, которым админ разрешил просрочку, срок не считается вовсе
export const getOrderDeadline = (order: ITableOrder): IOrderDeadline | null => {
  if (order.seller_id?.skip_order_deadlines) return null

  const limit = getStartAndLimit(order)
  if (!limit?.start) return null

  const deadline = dayjs(limit.start).add(limit.hours, 'hour')
  const minutesLeft = deadline.diff(dayjs(), 'minute')

  return {
    deadline,
    hoursLeft: Math.floor(Math.abs(minutesLeft) / 60),
    isOverdue: minutesLeft < 0,
    kind: limit.kind
  }
}
